// extracted by mini-css-extract-plugin
module.exports = {"formWidth":"Language_formWidth__3i7VZ","formContainer":"Language_formContainer__2SuGm","label":"Language_label__rjWzR"};